export default {
    'SET_USER' (state, payload) {
        state.user = payload
    },
    'SET_AUTH' (state, payload) {
        state.auth = payload
    },
    'SET_STATUS' (state, payload) {
        state.status = payload
    },
    'SET_CARRINHO' (state, payload) {
      state.carrinho = payload
    },
    'ADD_CARRINHO' (state, payload) {
      state.carrinho.push(payload)
    },
    'REMOVE_CARRINHO' (state, index) {
      state.carrinho.splice(index,1)
    },
}



// WEBPACK FOOTER //
// ./src/vuex/mutations.js